import React, { useRef, useState } from "react";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";



// components
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {
    FORM,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import { TT_HISTORY } from "../../../components/i18n/toolTips";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// services
import { fbChildPathService } from "../../../jwt/_services/firebase/fbChildPathService";

// providers
import {fbDatabaseProvider} from "../../../providers/fbDatabaseProvider";
import {mainProvider} from "../../../providers/mainProvider";


const FbChildPathForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;

    const [showModal, setShowModal] = useState(true)
    const [fbDataBaseId, setFbDataBaseId] = useState(domainObject?.db?.id || null);
    const [classCode, setClassCode] = useState(domainObject?.code || null);

    const modalRef = useRef(null);


    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        url: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            code: domainObject?.code,
            url: domainObject?.url,
            attributeIdentifier: domainObject?.attributeIdentifier,
            fieldMapping: domainObject?.fieldMapping,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data
        };

        if (fbDataBaseId !== null)
            dataRequest.db = { id : fbDataBaseId }



        if (editMode) {
            let id = domainObject.id;
            dataRequest.id = id

            genericActions.update(fbChildPathService, id, dataRequest)
        } else {
            genericActions.save(fbChildPathService, dataRequest)
        }


        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    return (<>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                    {/*    <Col md="8">*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Código / Clase</Label>*/}
                    {/*            <br/>*/}
                    {/*            <SelectGeneric*/}
                    {/*                isDisabled={ disableInputs }*/}
                    {/*                initialValue={ classCode }*/}
                    {/*                setExternalValue={ setClassCode }*/}
                    {/*                provider={ mainProvider }*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    </Row>
                    <Row>
                        <Col md="8">
                            <FormGroup>
                                <Input type="text" name="code" innerRef={register} value={ classCode } className={'hidden'}/>
                                <Label className={(errors.code ? 'label-is-invalid' : '')}>{ 'Paquete . Clase' }</Label>
                                <br/>
                                <SelectGeneric
                                    isDisabled={ disableInputs }
                                    hasError={ errors.code }
                                    initialValue={ classCode }
                                    setExternalValue={ setClassCode }
                                    provider={ mainProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label >{ 'Identificador de atributos' }</Label>
                                <Input type="number"
                                       name="attributeIdentifier"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="8">
                            <FormGroup>
                                <Label className={(errors.url ? 'label-is-invalid' : '')}>{ 'Path' }</Label>
                                <Input type="text" name="url"
                                       placeholder="/path/sub-path"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.url ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Base de datos</Label>
                                <br/>
                                <SelectGeneric
                                    isDisabled={ disableInputs }
                                    initialValue={ fbDataBaseId }
                                    setExternalValue={ setFbDataBaseId }
                                    provider={ fbDatabaseProvider }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label >{ 'Mapeo de campos' }</Label>
                                <Input type="textarea" name="fieldMapping"
                                       placeholder=""
                                       rows={10}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(FbChildPathForm)